export default __webpack_public_path__ + "static/media/placeholder_business05-it-mobile.9f706a29.png";